import ctl from "@netlify/classnames-template-literals";

export const headerContainer = ctl(`
  z-10 
  flex 
  items-center 
  justify-between 
  bg-purple-950 
  p-8 
  md:hidden
`);

export const sidebarContainer = ctl(`
  hidden 
  md:fixed 
  md:flex 
  md:h-full 
  md:w-56
  md:flex-col 
  md:items-start 
  md:border-r-purple-900
  md:bg-purple-950
  md:pt-10
`);

export const navigationItem = ctl(`
  flex 
  items-center 
  py-2 
  px-6 
  gap-4
`);

export const skeletonCircle = ctl(`
  w-6 
  h-6 
  bg-gray-300/40 
  rounded-full
`);

export const skeletonText = ctl(`
  h-6 
  bg-gray-300/40 
  rounded
`);

export const divider = ctl(`
  border-0 
  border-t 
  border-neutral-700 
  my-4
`);

export const sectionHeader = ctl(`
  ml-4 
  h-3 
  w-28
  bg-gray-300/40 
  rounded 
  mb-2
`);

export const adminToolsButton = ctl(`
  flex 
  items-center 
  justify-between 
  py-2 
  px-4 
  gap-6 
  bg-neutral-100 
  rounded-lg
`);

export const mobileHeaderButton = ctl(`
  animate-pulse 
  w-24 
  h-10 
  flex 
  gap-6 
  rounded-lg 
  bg-purple-900
  py-2 
  px-4 
  text-white
`);
